import { render, staticRenderFns } from "./Sidebar3pl.vue?vue&type=template&id=d64d4512&scoped=true"
import script from "./Sidebar3pl.vue?vue&type=script&lang=js"
export * from "./Sidebar3pl.vue?vue&type=script&lang=js"
import style0 from "./Sidebar3pl.vue?vue&type=style&index=0&id=d64d4512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64d4512",
  null
  
)

export default component.exports